// ================================
// SYNC WITH FRONTEND/OVERLAYS/BASE
// ================================

import React from "react";
import { Dialog } from "material-ui";

import CloseIcon from "material-ui/svg-icons/navigation/close";

const bodyStyle = {
  fontSize: 13,
  color: "#000"
};
const bodyStyleSlim = {
  overflowY: "visible"
};
const rootStyle = {
  overflowY: "scroll",
  background: "rgba(0, 0, 0, 0.541176)"
};
const contentStyle = {
  position: "relative",
  width: "90%",
  paddingBottom: 74
};
const overlayStyle = {
  position: "absolute",
  background: "none"
};
const hiddenTitleStyle = {
  borderBottom: "none"
};
const hiddebActionsContainerStyle = {
  borderTop: "none"
};

class BaseOverlay extends React.Component {
  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps() {
    // Modal dismissal
    // SYNC WITH FRONTEND
    // Handle tap on bottom padding (see contentStyle ^)
    // Without this, tap events on the bottom 74 px padding are lost and don't dismiss.

    if (!this.contentNode || this.hasSetUpDismissal) {
      return;
    }
    this.hasSetUpDismissal = true;

    setTimeout(() => {
      let content = this.contentNode.parentNode.parentNode,
        contentContainer = content.parentNode;

      contentContainer.addEventListener("click", e => {
        if (
          !content.contains(e.target) &&
          this.props.onRequestClose &&
          !this.props.disableBackgroundDismiss
        ) {
          e.preventDefault();
          e.stopPropagation();
          this.props.onRequestClose();
        }
      });
    }, 100); // wait for container to mount before adding listener
  }

  render() {
    let {
      children,
      useMuiDefaultStyle,
      hideTitleAndFooterBorders,
      titleStyle,
      actionsContainerStyle,
      dialogContentStyle,
      onRequestClose,
      ...others
    } = this.props;

    if (hideTitleAndFooterBorders) {
      titleStyle = Object.assign({}, hiddenTitleStyle, titleStyle);
      actionsContainerStyle = Object.assign(
        {},
        hiddebActionsContainerStyle,
        actionsContainerStyle
      );
    }

    return (
      <Dialog
        open={true}
        bodyStyle={!useMuiDefaultStyle ? bodyStyle : bodyStyleSlim}
        style={rootStyle}
        contentStyle={Object.assign({}, contentStyle, dialogContentStyle)}
        overlayStyle={overlayStyle}
        titleStyle={titleStyle}
        actionsContainerStyle={actionsContainerStyle}
        autoDetectWindowHeight={false}
        onRequestClose={
          this.props.disableBackgroundDismiss ? undefined : onRequestClose
        }
        {...others}
      >
        <div
          ref={r => {
            this.contentNode = r;
          }}
        >
          {this.props.showCloseButton ? (
            <CloseIcon
              style={{
                width: 20,
                height: 20,
                position: "absolute",
                right: 24,
                top: 24,
                cursor: "pointer"
              }}
              onTouchTap={this.props.onRequestClose}
            />
          ) : null}
          {this.props.children}
        </div>
      </Dialog>
    );
  }
}

export default BaseOverlay;



// WEBPACK FOOTER //
// ./src/app/components/partials/overlays/base.jsx